import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DilysuService } from '../defnyddiwr/dilysu.service';

@Injectable({
    providedIn: 'root'
})
export class GuardsService  {

    constructor(private dilysuService: DilysuService) { }

    canActivate(
        _next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {

        if (this.dilysuService.wediMewngofnodi()) {
            return true;
        }

        this.dilysuService.mewngofnodi();
        
        return false;
    }
}
